var quiz = {
    questions: [{
        text: "Over 95% of Martian air is composed of",
        responses: [{
            text: "Nitrogen",
            index: 'A'
          },
          {
            text: "Carbon di Oxide",
            index: 'B',
            correct: true
          },
          {
            text: "Methane",
            index: 'C'
          },
          {
            text: "Sulphur ",
            index: 'D'
          }
        ]
      },
      {
        text: "The ratio of atmospheric pressure on earth’s surface to that of Mars’ is roughly equal to:",
        responses: [{
            text: "183",
            index: 'A'
          },
          {
            text: "126",
            index: 'B'
          },
          {
            text: "166",
            index: 'C',
            correct: true
          },
          {
            text: "12",
            index: 'D'
          }
        ]
      },
      {
        text: "The Mach Effect in rocket propulsion theory refers to the idea that",
        responses: [{
            text: "Thrust can be achieved when an object experiences changes in its mass slightly when undergoing acceleration;",
            index: 'A',
            correct: true
          },
          {
            text: "Thrust can be achieved when accelerating the rocket to 1.85 times the speed of sound;",
            index: 'B'
          },
          {
            text: "Thrust can be achieved when accelerating the rocket to 3.25 times the speed of sound;",
            index: 'C'
          },
          {
            text: "Thrust can be reduced by keeping the momentum constant over time;",
            index: 'D'
          }
        ]
      },
      {
        text: "The ideal rocket equation was formally proposed and independently derived in the twentieth century by?",
        responses: [{
            text: "Albert Einstein",
            index: 'A'
          },
          {
            text: "Donald Lynden-Bell",
            index: 'B'
          },
          {
            text: "Konstantin Tsiolkovsky",
            index: 'C',
            correct: true
          },
          {
            text: "Ernst Mach",
            index: 'D'
          }
        ]
      },
      {
        text: "The ratio of earth’s radius to that of the moon is:",
        responses: [{
            text: "3.7",
            index: 'A'
          },
          {
            text: "3.2",
            index: 'B'
          },
          {
            text: "3.1",
            index: 'C',
            correct: true
          },
          {
            text: "2.9",
            index: 'D'
          }
        ]
      }
    ]
  },
  userResponseSkelaton = Array(quiz.questions.length).fill(null);
import {
  bus
} from '../../main';
var $ = window.jQuery = require('jquery');
import VueCircle from 'vue2-circle-progress/src/index.vue'
import Vue from 'vue'
export default {
  name: 'quiz-format',
  components: {
    VueCircle
  },
  props: [],
  data() {
    return {
      fill: {
        color: "#0cbfe9"
      },
      quiz: quiz,
      questionIndex: 0,
      userResponses: [],
      quizStarted: true,
      isActive: false,
      totalTime: 90,
      totalScore: 0,
      countDown: {
        minutes: "00",
        seconds: "00"
      }
    }
  },
  computed: {

  },
  mounted() {
    var totalTime = new Date();
    totalTime.setSeconds(totalTime.getSeconds() + this.totalTime);
    this.initializeTimer(totalTime);
  },
  methods: {
    selectOption: function(index) {
      Vue.set(this.userResponses, this.questionIndex, index);
    },
    next: function() {
      if (this.questionIndex < this.quiz.questions.length) {
        this.questionIndex++;
        this.score()
      }
    },
    prev: function() {
      if (this.quiz.questions.length > 0) this.questionIndex--;
    },
    // Return "true" count in userResponses
    score: function() {
      var score = 0;
      for (let i = 0; i < this.userResponses.length; i++) {
        if (
          typeof this.quiz.questions[i].responses[
            this.userResponses[i]
          ] !== "undefined" &&
          this.quiz.questions[i].responses[this.userResponses[i]].correct
        ) {
          score = score + 1;
        }
      }
      this.totalScore = score;
      return score;
    },

    //   CountDown
    initializeTimer: function(endTime) {
      var _self = this;

      function updateClock() {
        let remainTime = _self.getTimeRemaining(endTime)
        _self.countDown = remainTime;
        _self.UpdatePercentage(remainTime.total);
        if (remainTime.total <= 0) {
          clearInterval(timeinterval);
        }
      }
      updateClock();
      var timeinterval = setInterval(updateClock, 1000);
    },
    getTimeRemaining(endTime) {
      var t = Date.parse(endTime) - Date.parse(new Date());
      var seconds = Math.floor((t / 1000) % 60);
      var minutes = Math.floor((t / 1000 / 60) % 60);
      return {
        'total': t,
        'minutes': minutes,
        'seconds': seconds
      };
    },
    UpdatePercentage(remainTime) {
      let totalTime = (this.totalTime) * 1000;
      let percentage = 100 - ((remainTime * 100) / totalTime)
      if (this.$refs.timerRef)
        this.$refs.timerRef.updateProgress(percentage);
    },
    showCategory() {
      $('.quizzort_popup_wrp').removeClass('popup_slide_active')
      setTimeout(() => {
        bus.$emit('showQuizGameSpace', false);
      },500);
      setTimeout(() => {
        bus.$emit('hideQuizCategory', true);
      }, 500);
      setTimeout(() => {
      $('.quizzort_popup_wrp').addClass('popup_slide_active')
      }, 600);
    },
    QuizGamePopupClose() {
      $(".quizzort_main_wrp").removeClass("popup_active");
      setTimeout(() => {
        bus.$emit('showQuizGameSpace', false);
        bus.$emit('hideQuizzortPopupEnabled', false);
        $("body").removeClass("quizzort_popup_active");
      },500)
    },
  },

}